import {
  useParams
} from 'react-router-dom';
import React, {useState,useEffect,useRef} from 'react';
import {officesApi} from '../app/offices.js'
import Missions from '../Components/Missions.jsx'
import { selectCanAccess } from '../app/auth.js'
import { useSelector, useDispatch } from 'react-redux'
import { Navigate } from 'react-router-dom';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import { Accordion, AccordionDetails, AccordionSummary, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Badge from '@mui/material/Badge';



function CsvImporterPage(props) {
  const [fields, setFields] = useState([]); // The template state
  const [csvRows, setCsvRows] = useState([]); // The csv
  const [formValues, setFormValues] = useState({}); // Things useful in the page but that should be present in the template


  const selectRefs = useRef({});
  const field_values = useState({}); 

  const make_id_from_text = (text) => {
    return text.normalize("NFD").replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
  }

  const getSelectValue = (key, default_value) => {
    return selectRefs.current[key]?.value || default_value;
  };


  const setFormValue = (key, value) => {
    setFormValues({
      ...formValues,
      ...{[key]: value}
    })
  }
  const getFormValue = (key, default_value) => {
    return formValues[key] ? formValues[key] : default_value;
  }


  // Save template as file
  const save_template_file = () => {
    // Prepare the file
    const textContent = JSON.stringify({
      "fields": fields
    });
    const fileName = (new Date()).toISOString() + ".json";
    const blob = new Blob([textContent], { type: "application/json" });
    // Make the browser download the file
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href); // Clean up the URL object
  }

  // Open template from file
  const open_template_file = () => {
    const file_input = document.createElement("input");
    file_input.setAttribute("type", "file");
    file_input.addEventListener("change", (event) => {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();

      reader.onload = (e) => {
        const content = JSON.parse(e.target.result);
        // Parse it
        setFields(content.fields)
        document.body.removeChild(file_input);
      };

      reader.onerror = () => {
        alert("Error reading file");
        document.body.removeChild(file_input);
      };

      reader.readAsText(file); // You can change this if you want other formats
    })
    document.body.appendChild(file_input);
    file_input.click();
  }

  const open_csv_file = () => {
    const file_input = document.createElement("input");
    file_input.setAttribute("type", "file");
    file_input.addEventListener("change", (event) => {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();

      reader.onload = (e) => {
        const content = e.target.result;
        // Parse it
        //setFields(content.fields)
        const rows = content.trim().split('\n');
        const headers = rows[0].split(';').map((el) => el.trim());

        const result = rows.slice(1).map(row => {
          const values = row.split(';');
          return headers.reduce((obj, header, index) => {
            obj[header] = values[index];
            return obj;
          }, {});
        });
        setCsvRows(result)
        document.body.removeChild(file_input);
      };

      reader.onerror = () => {
        alert("Error reading file");
        document.body.removeChild(file_input);
      };

      reader.readAsText(file); // You can change this if you want other formats
    })
    document.body.appendChild(file_input);
    file_input.click();
  }


  
  const compute_annotations = (csvRows) => {
    let errors = [];
    let csv_annotations = [];
    if (getFormValue("default_id") == null) return {errors: errors, csv_annotations: csv_annotations, csv_headers: []};

    // Headers
    let headers = {};
    for (const row of csvRows){
      for (const k of Object.keys(row)){
        headers[k] = true;
      }
    }
    headers = Object.keys(headers)

    // Check mandatory columns
    for (const k of ["NumPoint", "X", "Y"]){
      if (!headers.includes(k)){
        errors.push("Missing column: " + k)
      }
    }

    // Group by:
    const grouped = csvRows.reduce((acc, item) => {
      const key = item[getFormValue("default_id")];
      if (!acc[key]) {
        acc[key] = {
          "unique_id": key,
          "rows": []
        };
      }
      acc[key].rows.push(item);
      return acc;
    }, {});

    // Check unique values
    for (const header of headers){
      if (["NumPoint", "X", "Y"].includes(header)) continue;
      let pbs = false;
      for (const def_id of Object.keys(grouped)){
        const unique_values = new Set(grouped[def_id].rows.map((el) => el[header]))
        if (unique_values.size > 1){
          pbs = true;
        }
        else{
          grouped[def_id][header] = unique_values[0];
        }
      }
      if (pbs){
        errors.push("More than 1 value for column " + header);
      }
    }

    // 

    // return 
    return {errors: errors, csv_annotations: csv_annotations, csv_headers: headers};
  }
  const tmp = compute_annotations(csvRows);
  const csv_annotations = tmp.csv_annotations;
  const csv_headers = tmp.csv_headers;
  const errors = tmp.errors;
  console.log("JFDIEOJDIODEZ")
  console.log(csv_annotations)
  console.log(errors)



  const addField = () => {
    const title = document.getElementById("new_field_title").value;
    const type = getFormValue("new_field_type", "select");
    if (type === "select"){
      setFields([...fields, 
        {
          "name": make_id_from_text(title),
          "title": title,
          "type": type,
          "options": [],
          "depends_on": ""
        }
      ]);
    }
    else if (type === "number"){
      setFields([...fields, 
        {
          "name": make_id_from_text(title),
          "title": title,
          "type": type,
          "min": "0",
          "max": "0",
          "default": ""
        }
      ]);
    }
    else if (type === "textarea"){
      setFields([...fields, 
        {
          "name": make_id_from_text(title),
          "title": title,
          "type": type,
          "default": ""
        }
      ]);
    }
  }

  const addOption = (field_name) => {
    console.log("addOption")
    console.log(field_name)
    const val = document.querySelector(`#field_${field_name} .new_option_name`).value
    console.log("val: ")
    console.log(val)
    const new_fields = fields;
    const field = new_fields.find((field) => field.name === field_name);
    if (field.options.filter((opt) => opt.text === val).length > 0){
      alert("Error! there is already an option with this name!")
    }
    else{
      field.options.push({
        "text": val,
        "parent_options": {}
      });
      setFields([...new_fields]);
    }
  }

  const updateField = (field_name, new_field_elements) => {
    const new_fields = fields;
    for (let i=0; i<new_fields.length; i++){
      if (new_fields[i].name === field_name){
        new_fields[i] = {...new_fields[i], ...new_field_elements};
      }
    }
    setFields([...new_fields]);
  }

  const updateOption = (field_name, option_id, new_field_elements) => {
    console.log("updateOption")
    const new_fields = fields;
    for (let i=0; i<new_fields.length; i++){
      if (new_fields[i].name === field_name){
        console.log("found field")
        for (let k=0; k<new_fields[i].options.length; k++){
          console.log([new_fields[i].options[k].text, option_id])
          if (new_fields[i].options[k].text === option_id){
            console.log("found opt")
            new_fields[i].options[k] = {
              ...new_fields[i].options[k],
              ...new_field_elements
            }
            console.log(new_fields[i].options[k])
          }
        }
      }
    }
    setFields([...new_fields]);
  }

  const setDependency = (field_name, child_option_text, parent_option_text, valid) => {
    const new_fields = fields;
    for (let field of fields){
      if (field.name !== field_name) continue;
      for (let child_option of field.options){
        if (child_option.text !== child_option_text) continue;
        child_option["parent_options"][parent_option_text] = valid;
      }
    }
    setFields([...new_fields]);
  }

  // Generate a view JSON
  const make_spec = () => {
    let keys = [];

    // For each field (field to be seen as a form input for the user)
    for (const field of fields){
      // TODO:
      // ADD COLORS (plus tard)

      // NUMBER
      if (field.type === "number"){
        keys.push({
          "type": "number",
          "name": field.name,
          "title": field.title,
          "default": field.default,
          "max": parseFloat(field.max),
          "min": parseFloat(field.min)
        });
      }
      // TEXTAREA
      else if (field.type === "textarea"){
        keys.push({
          "type": "textarea",
          "name": field.name,
          "title": field.title,
          "default": field.default
        });
      }
      // SELECT
      else if (field.type === "select"){
        if (field.depends_on === ""){
          let key = {
            "name": field.name,
            "title": field.title,
            "type": field.type
          }
          key.options = field.options.map((opt) => {
            // Compute option id:
            const opt_id = make_id_from_text(opt.text);
            // Check if there are submenus
            const child_fields = fields.filter((candidate_field) => {
              if (candidate_field.name === field.name) return false; // Discard the current field
              else if (candidate_field.depends_on === field.name) return true;
              else return false;
            })
            // Make the option
            let option = {
              "id": opt_id,
              "text": opt.text
            }
            if (child_fields.length > 0){
              option.submenus = child_fields.map((child_field) => opt_id + "-" + child_field.name);
            }
            // Symbology
            if (opt.symbology != null){
              console.log("SYMBOLOGY")
              console.log(opt.symbology)
            }
            if (opt.symbology != null && opt.symbology["[]"] != null && opt.symbology["[]"].color != null){
              option["color"] = opt.symbology["[]"].color;
            }
            return option;
          })
          key.default = key.options.length > 0 ? key.options[0].id : null;
          keys.push(key);
        }
        else{
          const parent_keys = keys.filter((key) => key.name === field.depends_on);
          for (const parent_key of parent_keys){
            for (const parent_opt of parent_key.options){
              const prefix = parent_opt.id + "-";
              const child_options = field.options.filter((child_opt) => child_opt.parent_options[parent_opt.text]).map((opt) => {
                // Compute option id:
                const opt_id = prefix + make_id_from_text(opt.text);
                // Check if there are submenus
                const child_fields = fields.filter((candidate_field) => {
                  if (candidate_field.name === field.name) return false; // Discard the current field
                  else if (candidate_field.depends_on === field.name) return true;
                  else return false;
                })
                // Make the option
                let option = {
                  "id": opt_id,
                  "text": opt.text
                }
                if (child_fields.length > 0){
                  option.submenus = child_fields.map((child_field) => opt_id + "-" + child_field.name);
                }
                return option;
              });
              let key = {
                "id": prefix + field.name,
                "name": field.name,
                "title": field.title,
                "type": field.type
              }
              key.options = child_options;
              key.default = key.options.length > 0 ? key.options[0].id : null;
              keys.push(key);
            }
          }
        }
      }
      else {
        return {"error": "unknown field " + field.type}
      }
    }
    return {"keys": keys}
  }

  // Render a generic field
  const renderField = (field, field_index) => {
    if (field.type === "select"){
      return renderSelectField(field, field_index);
    }
    else if (field.type === "number"){
      return renderNumberField(field, field_index);
    }
    else if (field.type === "textarea"){
      return renderTextAreaField(field, field_index);
    }
    else{
      return <h1>Error</h1>
    }
  }


  // Number
  const renderNumberField = (field, field_index) => {
    return <p id={"field_" + field.name}>
      <h1>Field #{field_index+1}: {field.title} [{field.type}]</h1>
      Name: <input type="text" value={field.title} onChange={(e) => { updateField(field.name, {"title": e.target.value}) }}></input><br/>
      Min: <input type="number" value={field.min} onChange={(e) => { updateField(field.name, {"min": e.target.value}) }}></input><br/>
      Max: <input type="number" value={field.max} onChange={(e) => { updateField(field.name, {"max": e.target.value}) }}></input><br/>
      Default: <input type="number" value={field.default} onChange={(e) => { updateField(field.name, {"default": e.target.value}) }}></input><br/>
    </p>
  }

  // TextArea
  const renderTextAreaField = (field, field_index) => {
    return <p id={"field_" + field.name}>
      <h1>Field #{field_index+1}: {field.title} [{field.type}]</h1>
      Name: <input type="text" value={field.title} onChange={(e) => { updateField(field.name, {"title": e.target.value}) }}></input><br/>
      Default: <input type="number" value={field.default} onChange={(e) => { updateField(field.name, {"default": e.target.value}) }}></input><br/>
    </p>
  }

  // Select
  const renderSelectField = (field, field_index) => {
    
    // Get dependance values
    let dependance_options = [];
    if (field.depends_on != ""){
      let other_field = fields.filter((field2) => field2.name === field.depends_on)[0];
      dependance_options = other_field.options;
    }
    

    return <p id={"field_" + field.name}>
      <h1>Field #{field_index+1}: {field.title} [{field.type}]</h1>
      Name: <input type="text" value={field.title} onChange={(e) => { updateField(field.name, {"title": e.target.value}) }}></input><br/>
      Depends on: <select value={field.depends_on} onChange={(e) => {
        console.log(e)
        console.log(e.target.value)
        updateField(field.name, {"depends_on": e.target.value})
      }}>
        <option value="">None</option>
        {fields.filter((field2) => (field2.name !== field.name && field2.type === "select")).map((field2) => {
          return <option value={field2.name}>{field2.title}</option>
        })}
      </select><br/><br/>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Options</TableCell>
              {dependance_options.map((opt) => { 
                return <TableCell>{opt.text}</TableCell>
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {field.options.map((option) => {
              return <TableRow key={option.text}>
                <TableCell>{option.text}</TableCell>
                {dependance_options.map((opt) => { 
                  return <TableCell><input type="checkbox" checked={option.parent_options[opt.text]} onChange={(e) => setDependency(field.name, option.text, opt.text, e.target.checked)}></input></TableCell>
                })}
              </TableRow>;
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <input class="new_option_name" type="text"></input><button onClick={() => addOption(field.name)}>Add an option</button><br/>
    </p>
  }

  const make_tree_list = (condition, fields) => {
    let list = [];
    if (fields.length > 0){
      const field = fields[0];
      for (let opt of field.options){
        // If valid:
        if (condition == null || opt.parent_options[condition] === true){
          if (fields.length > 1){
            let subresult = make_tree_list(opt.text, fields.slice(1));
            for (let subelt of subresult){
              list.push([opt.text].concat(subelt));
            }
          }
          else{
            list.push([opt.text]);
          }
        }
      }
    }
    return list;
  }

  // renderSymbology
  const renderSymbology = () => {
    // Child and parents
    const selects = fields.filter((field) => field.type === "select");
    let child_to_parent = {};
    for (let field of selects){
      if (field.depends_on){
        child_to_parent[field.name] = field.depends_on;
      }
    }
    let parent_to_child = {};
    for (let child of Object.keys(child_to_parent)){
      parent_to_child[child_to_parent[child]] = child;
    }

    // 
    let trees = [];
    for (let field of selects){
      // Ignore parents
      if (parent_to_child[field.name]) continue;
      // Compute ancesters
      let ancesters = [field]
      if (child_to_parent[field.name]){
        // safer while true
        let current_name = field.name;
        for (let i=0; i<selects.length; i++){
          current_name = child_to_parent[current_name];
          if (current_name == null) break;
          else ancesters.unshift(selects.filter((el) => el.name === current_name)[0]);
        }
      }
      // Make tablebody
      let tablebody = [];
      for (let list_elt of make_tree_list(null, ancesters)){
        // Find value
        const field_name = ancesters[ancesters.length-1].name;
        let opt = ancesters[ancesters.length-1].options.find((opt) => opt.text === list_elt[list_elt.length-1]);
        const option_id = opt.text;
        let rule_condition = JSON.stringify(list_elt.slice(0, -1));
        let symbology = JSON.parse(JSON.stringify(opt.symbology ? opt.symbology : {}))

        // Text field
        const textField = <TextField onChange={(e) => {
          // Find RGB value 
          const regex = /\s*[\(]?\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*[\)]?/;
          const match = e.target.value.match(regex);
          // If RGB is detected, let's save the color
          if (match){
            const r = parseInt(match[1]);
            const g = parseInt(match[2]);
            const b = parseInt(match[3]);
            symbology[rule_condition].color = [r, g, b];
            updateOption(field_name, option_id, {"symbology": symbology});
          }
          // Otherwise, disable color
          else{
            symbology[rule_condition].color = null;
            updateOption(field_name, option_id, {"symbology": symbology});
          }
        }} label="Color (R, G, B). Example: (255, 0, 0)" value={symbology[rule_condition]?.color} variant="outlined" />;

        // Add table row
        tablebody.push(<TableRow>
          {list_elt.map((title) => <TableCell>{title}</TableCell>)}
          <TableCell>
            {symbology[rule_condition]?.color && <Badge style={{"background-color": `rgb(${symbology[rule_condition]?.color[0]}, ${symbology[rule_condition]?.color[1]}, ${symbology[rule_condition]?.color[2]})`}} badgeContent=" ">{textField}</Badge>}
            {!symbology[rule_condition]?.color && textField}
          </TableCell>
        </TableRow>)
      }

      //
      let tree = <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow>
              {ancesters.map((field) => { 
                return <TableCell>{field.title}</TableCell>
              })}
              <TableCell>Symbology</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tablebody}
          </TableBody>
        </Table>
      </TableContainer>;
      trees.push(tree);
      trees.push(<br/>);
    }

    return <>{trees}</>
  }

  // TODO:
  // - pouvoir gérer les couleurs
  // - pouvoir définir les valeurs par défaut
  return <React.Fragment>
    

    <Container >
      <Grid container spacing={3} direction="column">

        <Grid item >
          
          <Button variant="outlined" onClick={open_template_file}>Open symbology file</Button><br/>
          <Button variant="outlined" onClick={open_csv_file}>Open CSV file</Button><br/>
          <Button variant="outlined">Save annotations</Button><br/>
        </Grid>

        <Grid item >
          <h1>Annotation ID</h1>
          Choose the column in the CSV to use to identify the annotation:<br/>
          {csvRows.length > 1 && 
            <Select value={getFormValue("default_id")} onChange={(el) => {setFormValue("default_id", el.target.value)}}>
              {Object.keys(csvRows[0]).map((col_name) => {
                return <MenuItem value={col_name}>{col_name}</MenuItem>
              })}
            </Select>
          }
        </Grid>

        <Grid item >
          <h1>Analysis</h1>
          {errors.length > 0 && <div style={{"color": "red"}}>
            Errors found:<ul>
              {errors.map((err) => {return <li>{err}</li>; }) }
            </ul>
          </div>}
          There are {csv_annotations.length} annotations found in the CSV.
        </Grid>


        <Grid item >
          <h1>List of fields</h1>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }}>
              <TableHead>
                <TableRow>
                  <TableCell>Field in symbology</TableCell>
                  <TableCell>Field to use in CSV</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {fields.map((key) => {
                  return <TableRow>
                    <TableCell>{key.title}</TableCell>
                    <TableCell>
                      <Select value={getFormValue("field_mapping_" + key.title, "null")} onChange={(el) => {setFormValue("field_mapping_" + key.title, el.target.value)}}>
                        <MenuItem value={"null"}>None (use default value)</MenuItem>
                        {csv_headers.map((header) => {
                          return <MenuItem value={header}>{header}</MenuItem>
                        })}
                      </Select>
                    </TableCell>
                  </TableRow>;
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>

        <Grid item >
          <h1>List of options</h1>
          <ul>
          {fields.map((key) => {
            return <li>{key.title} [{key.type}]</li>
          })}
          </ul>
          <Stack direction="row" spacing={2}>
            <TextField id="new_field_title" />
            <FormControl fullWidth>
              <Select id="new_field_type" value={getFormValue("new_field_type", "select")} onChange={(el) => {setFormValue("new_field_type", el.target.value)}}>
                <MenuItem value="select">select</MenuItem>
                <MenuItem value="number">number</MenuItem>
                <MenuItem value="textarea">textarea</MenuItem>
              </Select>
            </FormControl>
            <Button variant="outlined" onClick={() => {addField()}}>
              Add
            </Button>
          </Stack>
        </Grid>

        {fields.map((field, field_index) => {
          return renderField(field, field_index);
        })}

        <h1>Symbology</h1>
        {renderSymbology()}

        <br/><br/><br/><br/><br/><hr/><br/><br/><br/>
        

        <hr/>
        <h1>Auto-generated View JSON</h1>
        <textarea style={{height: "200px"}} value={JSON.stringify({
          "spec": {
            "description": make_spec(),
            "sidebarConfig": {
              "categoryKey": "category",
              "levelKey": null,
              "titleKey": "title"
            }
          }
        }, null, 2)}></textarea>
        TODO:
        <ul>
          <li>Pouvoir choisir les default value pour les select</li>
          <li>Pouvoir supprimer/déplacer les fields/options</li>
          <li>Faire plus de checks sur arbres de select (pas sûr que ça fonctionne avec 3 niveaux)</li>
          <li>Revoir les choix de symbologie pour les arbres</li>
          <li>Gérer symbologie fill_pattern/symbol</li>
        </ul>

        <br/><br/><br/><br/><br/><hr/><br/><br/><br/>

      </Grid>
    </Container>
  </React.Fragment>
}

export default CsvImporterPage